import { toValidDate } from "../../customView/customViewMailEntry";
import {
    CreateCustomViewRequestBody,
    CustomViewDTO,
    PatchCustomViewRequestBody,
} from "../../customView/types/customViewData.api";
import {
    CustomView,
    CustomViewInput,
    CustomViewPatchParams,
    SmartLabelEntry,
} from "../../customView/types/customViews";
import { MailSmartLabelEntryDTO } from "../../customView/types/smartLabel.api";

export function toDomainSmartLabelEntry(
    dto: MailSmartLabelEntryDTO,
): SmartLabelEntry {
    return {
        id: dto.internetMessageId,
        date: new Date(dto.sentDateTime),
        score: dto.score,
        manualFocusDate: dto.manualFocusDate ?? null,
        sentDateTimeMailvista: dto.sentDateTimeMailvista ?? null,
    };
}

export function toDomainCustomView(dto: CustomViewDTO): CustomView {
    return {
        id: dto.id,
        userId: dto.userId,
        name: dto.name,
        icon: dto.icon,
        viewType: dto.viewType,
        filters: {
            keywords: dto.filters.keywords,
            startDate: dto.filters.startDate,
            endDate: dto.filters.endDate,
            identifiedSenders: dto.filters.identifiedSenders,
            identifiedRecipients: dto.filters.identifiedRecipients,
            sortOrder: dto.filters.sortOrder,
        },
        displayMode: dto.displayMode,
        widgets: dto.widgets,
        createdAt: dto.createdAt,
        updatedAt: dto.updatedAt,
        isFavorite: dto.isFavorite,
        displayOrder: dto.displayOrder,
        userPrompt: dto.userPrompt,
        noteContent: dto.noteContent,
        internetMessageIds: dto.internetMessageIds,
        mails: dto.mails.map((mail) => ({
            internetMessageId: mail.internetMessageId,
            sentDateTime: toValidDate(mail.sentDateTime),
        })),
    };
}

export function toDtoCustomViewInput(
    input: CustomViewInput,
): CreateCustomViewRequestBody {
    return {
        name: input.name,
        icon: input.icon,
        displayMode: input.displayMode,
        widgets: input.widgets,
        userPrompt: input.userPrompt,
        filters: {
            keywords: input.filters.keywords,
            startDate: input.filters.startDate ?? null,
            endDate: input.filters.endDate ?? null,
            identifiedSenders: input.filters.identifiedSenders ?? [],
            identifiedRecipients: input.filters.identifiedRecipients ?? [],
            sortOrder: input.filters.sortOrder,
        },
    };
}

export function toDtoPatchParams(
    id: string,
    patch: CustomViewPatchParams,
): PatchCustomViewRequestBody {
    const body: PatchCustomViewRequestBody = { id };
    if (patch.name !== undefined) body.name = patch.name;
    if (patch.icon !== undefined) body.icon = patch.icon;
    if (patch.displayMode !== undefined) body.displayMode = patch.displayMode;
    if (patch.widgets !== undefined) body.widgets = patch.widgets;
    if (patch.displayOrder !== undefined)
        body.displayOrder = patch.displayOrder;
    if (patch.isFavorite !== undefined) body.isFavorite = patch.isFavorite;
    if (patch.noteContent !== undefined) body.noteContent = patch.noteContent;
    if (patch.mails !== undefined)
        body.mails = patch.mails.map((mail) => ({
            internetMessageId: mail.internetMessageId,
            sentDateTime: mail.sentDateTime
                ? mail.sentDateTime.toISOString()
                : null,
        }));
    if (patch.filters !== undefined) {
        body.filters = {
            keywords: patch.filters.keywords,
            startDate: patch.filters.startDate ?? null,
            endDate: patch.filters.endDate ?? null,
            identifiedSenders: patch.filters.identifiedSenders ?? [],
            identifiedRecipients: patch.filters.identifiedRecipients ?? [],
            sortOrder: patch.filters.sortOrder,
        };
    }
    return body;
}
